export default __webpack_public_path__ + "static/clustermesh-3-3ef1dc022891ab8ab90d33cee19892d0.png";